import { createSlice } from "@reduxjs/toolkit";
import { uniqBy } from "lodash";

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    items: [],
  },
  reducers: {
    setNotifications: (state, { payload }) => {
      state.items = uniqBy(
        [...state.items, ...payload],
        (notification) => `${notification.type}${notification.targetId}`
      );
    },
    removeNotification: (state, { payload }) => {
      state.items = state.items.filter(
        (notification) =>
          notification.targetId !== payload.targetId ||
          notification.type !== payload.type
      );
    },
    markNotificationAsRead: (state, { payload }) => {
      state.items = state.items.map((notification) =>
        notification.targetId == payload.targetId &&
        notification.type === payload.type
          ? {
              ...notification,
              unread: false,
            }
          : notification
      );
    },
  },
});

// SELECTORS

export const selectNotifications = (state) => state.notifications.items;

// ACTIONS

export const { setNotifications, removeNotification, markNotificationAsRead } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
